export default "__VITE_ASSET__CcSWiuaX__"